import { BasePage } from '@/components/ui/base-page'

export function ReportsPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add ReportsPage specific content here */}
    </BasePage>
  )
}